import React, { Component } from 'react';
import PropTypes from 'prop-types';

import uuid from 'uuid';
import _isEqual from 'lodash/isEqual';

import { dictionaryColumnType } from 'types';

import AddNewRowCol from './components/AddNewRowCol';

export const getDefaultValues = ({ columns }) => ({
  token: '',
  columns: columns.map(col => ({
    ...col,
    value: '',
  })),
});

class AddNewRow extends Component {
  static propTypes = {
    onFocus: PropTypes.func.isRequired,
    columns: PropTypes.arrayOf(dictionaryColumnType),
    focus: PropTypes.shape({
      col: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      row: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    onSaveNewEntry: PropTypes.func,
  };

  state = getDefaultValues(this.props);

  componentWillReceiveProps(nextProps) {
    if (!_isEqual(nextProps.columns, this.props.columns)) {
      this.updateColumns(nextProps);
    }
  }

  updateColumns(nextProps) {
    this.setState(prevState => ({
      token: '',
      columns: nextProps.columns.map(col => {
        const prevCol = prevState.columns[col.id];
        if (prevCol) {
          return { ...col, value: prevCol };
        }

        return {
          ...col,
          value: '',
        };
      }),
    }));
  }

  handleUpdateToken = ({ target: { value } }) => {
    this.setState({
      token: value,
    });
  };

  handleUpdateValue = (editedCol, value) => {
    this.setState({
      columns: this.state.columns.map(col => {
        if (!col.id || editedCol.id === col.id) {
          return {
            ...col,
            value,
          };
        }

        return col;
      }),
    });
  };

  handleKeyPress = e => {
    if (e.keyCode === 13) {
      this.handleUpdate();
    }
  };

  handleUpdate = () => {
    const { token, columns } = this.state;

    this.props.onSaveNewEntry({
      token,
      values: columns.reduce(
        (acc, col) => ({
          ...acc,
          [col.id]: col.value,
        }),
        {},
      ),
    });

    this.resetState();
    this.handleTokenFocus();
  };

  resetState = () => {
    this.setState(getDefaultValues(this.props));
  };

  handleRef = el => {
    this.inputComponent = el;
  };

  handleTokenFocus = () => {
    this.props.onFocus({
      row: -1,
      col: -1,
    });
  };

  render() {
    const { token, columns } = this.state;
    const { focus, onFocus } = this.props;

    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return (
      <tr onKeyDownCapture={this.handleKeyPress}>
        <th />

        <th>
          <input
            ref={this.handleRef}
            data-test="input-token"
            placeholder="Token"
            value={token}
            onChange={this.handleUpdateToken}
            onFocus={this.handleTokenFocus}
          />
        </th>

        {columns.map((col, index) => (
          <AddNewRowCol
            key={col.id || uuid()}
            col={col}
            focus={focus}
            index={index}
            onFocus={onFocus}
            onUpdate={this.handleUpdateValue}
          />
        ))}

        <th />
      </tr>
    );
  }
}

export default AddNewRow;
